import React from "react";

export default function Pause() {
  return <i className="fas fa-pause" />;
}
